import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, IconButton, Paper, Button } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import { Question } from './HiringExperienceConfiguration';
import { theme } from '../../../../../theme';
import { useParams } from 'react-router';
import { useSnackbar } from '../../../../../Context/SnackbarContext';
import { addOrUpdateHiringExperienceQuestions } from '../preboardingConfigurationApi';

interface CustomQuestionsProps {
    customQuestions: Question[];
    handleDeleteCustomQuestion: (value: number) => void;
    handleChangeCustomQuestion: (index: number, value: string) => void;
    fetchQuestions: () => void;
}
const CustomQuestions: React.FC<CustomQuestionsProps> = ({ customQuestions, handleDeleteCustomQuestion, handleChangeCustomQuestion, fetchQuestions }) => {
    const { tenant } = useParams<{ tenant: string }>();
    const [errors, setErrors] = useState<string[]>([]);
    const { showSnackbar } = useSnackbar();

    // 👉 Store refs for each text field
    const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

    // 👉 Focus & scroll when new question is added
    useEffect(() => {
        if (customQuestions.length > 0) {
            const lastIndex = customQuestions.length - 1;
            const lastInput = inputRefs.current[lastIndex];
            if (lastInput) {
                lastInput.scrollIntoView({ behavior: "smooth", block: "center" });
                lastInput.focus();
            }
        }
    }, [customQuestions.length]); // Runs only when a new question is added

    const handleSave = async (index: number) => {
        const value = customQuestions[index].Question;
        if (!value || value.trim() === "") {
            setErrors((prev) => {
                const newErrors = [...prev];
                newErrors[index] = "Question is required";
                return newErrors;
            });
            return;
        }
        setErrors((prev) => {
            const newErrors = [...prev];
            newErrors[index] = "";
            return newErrors;
        });

        try {
            // Add your save logic here
            const payLoad = {
                Question: value,
                QuestionNum: 0,
            }

            const result = await addOrUpdateHiringExperienceQuestions(payLoad, tenant);
            if (result) {
                showSnackbar(result.Message, result.Status ? "success" : "error");
                if (result.Status) {
                    fetchQuestions();
                    handleDeleteCustomQuestion(index);
                }
            }

        } catch (error) {
            console.log(error)
            showSnackbar("Failed to save question", "error");
        }
        // Otherwise, you can add your save logic here
    };

    const handleQuestionChange = (index: number, value: string) => {
        handleChangeCustomQuestion(index, value);
        setErrors((prev) => {
            const newErrors = [...prev];
            newErrors[index] = "";
            return newErrors;
        });
    };
    return (
        <Box mt='1vw'>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Add Custom Question</TableCell>
                            <TableCell align='center'>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {customQuestions.map((question, index) => (
                            <TableRow
                                key={index}
                                sx={{
                                    backgroundColor: index % 2 == 0 ? theme.palette.primary.light : 'inherit',
                                }}
                            >
                                <TableCell>
                                    <TextField
                                        fullWidth
                                        value={question.Question}
                                        onChange={(e) => handleQuestionChange(index, e.target.value)}
                                        placeholder="Enter custom question"
                                        error={!!errors[index]}
                                        helperText={errors[index]}
                                        inputRef={(el) => (inputRefs.current[index] = el)} // 👈 attach ref
                                    />
                                </TableCell>
                                <TableCell
                                    sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <IconButton color="primary" onClick={() => handleSave(index)} title='Save Question'>
                                        <SaveIcon />
                                    </IconButton>
                                    <IconButton color="primary" onClick={() => handleDeleteCustomQuestion(index)} title='Delete Question'>
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}

export default CustomQuestions